/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useState } from "react";
import { useSelector } from "react-redux";
import Budget from "../components/ListItems/Budget";
import { TransactionAllocation, BudgetItem, BudgetType, CurrentUser, DateTime, FamilyHasAccess, TimeframeItem, TransactionItem } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Grid, IconButton } from "@mui/material";
import { BoxArrowUpRight, PencilFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import Date from "../components/Inputs/Date";
import { Features } from "../constants";
import Unbudget from "../components/ListItems/Unbudget";

const FilteredBudgets = (props: any) => {
	const repo = useItems();
	const user: CurrentUser = useSelector((state: any) => state.userData.value);

	const navigate = useNavigate();

	const [currentDate, setCurrentDate] = useState(new DateTime());

	const isMobile: boolean = useSelector((state: any) => state.isMobile.value);

	const transactions: TransactionItem[] = useSelector((state: any) => state.transactions.value);
	const timeframes: TimeframeItem[] = useSelector((state: any) => state.timeframes.value);
	const budgets: BudgetItem[] = useSelector((state: any) => state.budgets.value);
	let filteredBudgets = budgets.filter(b => !b.isInactive);
	const inactiveBudgets = budgets.filter(b => b.isInactive);
	const showHoh = user.isHoH && !isMobile;

	const canLoad = transactions && timeframes && budgets && user;

	let earliest = new DateTime();
	let sumUnbudgeted = 0;

	let title = '';
	switch (location.pathname.toLowerCase()) {
		case "/budgets/income":
			filteredBudgets = filteredBudgets.filter(b => b.budgetType === BudgetType.Income);
			title = 'Income';
			break;
		case "/budgets/combined":
			filteredBudgets = filteredBudgets.filter(b => b.budgetType === BudgetType.Combined);
			title = 'Combined';
			break;
		case "/budgets/limited":
			filteredBudgets = filteredBudgets.filter(b => b.budgetType === BudgetType.Expense && b.variant.amount > 0);
			title = 'Limited';
			earliest = new DateTime([...filteredBudgets.filter(b => b.budgetType === BudgetType.Expense && b.variant.amount > 0)].map(b => b.variant.startDate.Value).reduce((minDate: Date, currentDate: Date) => currentDate < minDate ? currentDate : minDate, new DateTime().Value));
			sumUnbudgeted = ([] as TransactionAllocation[]).concat.apply([], transactions?.filter(t => t.transactionDate.startOfDay().Value >= earliest.Value).map(t => t.allocations?.filter(a => a.budgetId < 1))).reduce((total, t) => total + t.amount, 0);
			break;
		case "/budgets/unlimited":
			filteredBudgets = filteredBudgets.filter(b => b.budgetType === BudgetType.Expense && b.variant.amount === 0);
			title = 'Unlimited';
			break;
		case "/budgets/all":
			title = 'All';
			break;
		case "/budgets/inactive":
			title = 'Inactive';
			filteredBudgets = inactiveBudgets;
			break;
		default:
			navigate('/budgets');
	}

	if (!FamilyHasAccess(user, Features.Budgets)) {
		navigate("/");
		return <></>;
	}
	if (!FamilyHasAccess(user, Features.Taxes) && title !== 'All') {
		navigate("/budgets/all");
		return <></>;
	}

	return (
		<>
			<Grid container rowSpacing={3} justifyContent="center" alignContent="center" className="budget-list" columnSpacing={2}>
				<Grid item xs={8}>
					<h2 className="mt-2 text-app">{title} Budgets</h2>
				</Grid>
				<Grid item xs={3}>
					{!canLoad && (< p ><em>Loading...</em></p>)}
					{canLoad && showHoh && (
						<>
							<IconButton
								className="text-app right"
								aria-label='Edit Budgets'
								onClick={() => navigate('/bulkbudgets')}>
								<PencilFill />
							</IconButton>
						</>
					)}
				</Grid>
				{canLoad && (
					<div className="mb-3 start-hint">
						{
							filteredBudgets.filter(b => user.isHoH || b.isMine).slice().sort((a, b) => a.description.localeCompare(b.description)).map(budget => (
								<Budget
									Item={budget}
									CurrentDate={currentDate}
									OnClick={() => navigate(`/budget/${budget.budgetId}/${currentDate.toQueryString()}`)}
									key={`budget${budget.budgetId}`} />
							))
						}
						{sumUnbudgeted > 0 &&
							<Unbudget
								Since={earliest}
								Total={sumUnbudgeted}
								OnClick={() => navigate(`/unbudget`)}
								key={`budget0`} />
						}
						<Grid item xs={12} className="mt-3">
							{budgets.length > 0 ? (
								<>
									<Grid item xs={6} className="centered">
										<Date Borderless Size={12} Label="As of..." Value={currentDate} OnChange={UpdateDate} />
									</Grid>
								</>
							) : (
								<>
									<Grid item xs={3} className="centered align-self-center">
									</Grid>
									<Grid item xs={6} className="centered">
										<Date Size={12} Label="As of..." Value={currentDate} OnChange={UpdateDate} />
									</Grid>
									<Grid item xs={3} className="centered align-self-center">
									</Grid>
									<Grid item xs={3}></Grid>
									<Grid item xs={6} className="centered">
										{showHoh ? "Select the Pencil button above to add your first budget" : "You currently have no budgets assigned to you"}
									</Grid>
									<Grid item xs={3}></Grid>
								</>
							)}
						</Grid>
					</div>
				)}
			</Grid>
			{inactiveBudgets.length > 0 && filteredBudgets !== inactiveBudgets &&
				<Grid container className="border border-app my-1 budget-summary-container bg-white cursor-pointer" style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: -1, paddingRight: -1 }} onClick={() => navigate('/budgets/inactive')}>
					<Grid item xs={12} className='centered py-3 text-app'>
						<h3 className='mb-0 align-content-center'>View Inactive Budgets<BoxArrowUpRight style={{ marginLeft: '1rem' }} /></h3>
					</Grid>
				</Grid>
			}
		</>
	);

	function UpdateDate(newValue: any) {
		newValue = new DateTime(newValue);
		repo.GetBudgetsWithDateAsync(newValue);
		setCurrentDate(newValue);
	}
}

export default FilteredBudgets;